<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')">
      <template v-slot:title>
        <small v-if="id"> ({{ id }})</small>
        {{ getTitle() }}
      </template>
      <a-loader v-if="!loaded" />
      <div v-else-if="value">
        <slot name="form"> </slot>
        <v-row v-if="version == 1" class="mt-1 pt-2" style="overflow-y: auto; overflow-x: hidden">
          <v-col v-for="(el, i) in modelForm" :key="i" cols="12" :sm="el.size" class="py-0">
            <div v-for="name in el.name.split('+')" :key="name">
              <a-form-model
                :ref="'field_' + name"
                v-model="data"
                :model="getFormModel([name], model)"
                :errors="errors"
                :warnings="warnings"
                :config="{ dense: true, readonly, hideDetails: config.hideDetails || false, opt }"
                @validate="
                  validate($event);
                  doWatch($event);
                "
                @fieldData="setFieldData($event)"
              />
            </div>
          </v-col>
        </v-row>
        <a-form-model2
          v-else-if="version == 2"
          v-model="data"
          :modelForm="modelForm"
          :model="model"
          :errors="errors"
          :warnings="warnings"
          :config="{ dense: true, readonly, hideDetails: config.hideDetails || false, opt }"
          @validate="
            validate($event);
            doWatch($event);
          "
          @fieldData="setFieldData($event)"
        ></a-form-model2>
      </div>
      <template v-slot:actions>
        <slot name="actions"></slot>
        <v-spacer></v-spacer>
        <v-btn v-if="opt && opt.dataCopyButton" icon @click="pasteData" color="red">
          <v-icon>fas fa-paste</v-icon>
        </v-btn>
        <v-btn v-if="opt && opt.dataCopyButton" icon @click="copyData" color="green">
          <v-icon>fas fa-copy</v-icon>
        </v-btn>
        <a-btn-save :disabled="readonly" @click="_submit()" :color="isChanged ? 'green' : 'primary'"></a-btn-save>
        <a-btn-delete v-if="canDelete && id" :disabled="readonly" @click="removeDialogShow = true"></a-btn-delete>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
    <remove-dialog v-model="removeDialogShow" @remove="_remove(api, id)" :title="removeTitle" />
    <su-Data ref="suEdit" v-model="suEditShow" :api="api" :id="id" :activate="value" :dataEdit="data" @show="suEditShow = true" v-if="getAccess('suData')" />
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess, genModel } from "@/components/mixings";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, getAccess, genModel],
  props: {
    version: { type: [Number, String], default: 1 },
    value: Boolean,
    id: Number,
    m: Object,
    configForm: { type: Object, default: () => {} },
    hasData: { type: Boolean, default: false },
    initData: { type: Object, default: () => {} },
    opt: { type: Object, default: () => {} },
    params: { type: Object, default: () => {} },
    async: { type: Boolean, default: false },
  },
  data() {
    return {
      model: [],
      idEdit: 0,
      suEditShow: false,
      removeDialogShow: false,
      type: null,
      loaded: false,
      options: [],
      fieldData: {},
      clipboardHasValidJson: false,
      clipboardWatcher: null,
      _show: !this.async,
      _configForm: this.configForm,
      _m: this.m,
      _initData: this.initData,
      _opt: this.opt,
      _params: this.params,
      _id: this.id,
    };
  },
  computed: {
    config() {
      if (this.configForm?.head) return this.configForm.head;
      const type = this.configForm?.type || "default";
      return JSON.parse(JSON.stringify(this.m?.config?.[type] || {}));
    },
    api() {
      return this.configForm?.api || this.m?.api || null;
    },
    title() {
      return this.configForm?.title || this.m?.title || "";
    },

    canDelete() {
      return this.opt?.delete === true;
    },
    readonly() {
      if (this.opt?.readonly === true) return true;
      if (this.m?.params?.func?.readonly) {
        try {
          return eval(this.m.params.func.readonly)(this.data);
        } catch (error) {
          console.error("Ошибка readonly", error);
          return true;
        }
      }
      if (this.params?.func?.readonly) {
        try {
          return eval(this.params.func.readonly)(this.data);
        } catch (error) {
          console.error("Ошибка readonly");
          return true;
        }
      }
      return false;
    },
    removeTitle() {
      return this.m?.removeTitle || "Вы действительно хотите удалить это?";
    },
  },
  created() {
    this.loaded = false;

    if (!this.async) this.initForm();
  },
  mounted() {
    // проверяем буфер каждую секунду
    // if (!this.async) this.checkClipboard();
    // if (this.opt?.dataCopyButton) this.clipboardWatcher = setInterval(this.checkClipboard, 1000);
  },
  beforeDestroy() {
    //if (this.clipboardWatcher) {      clearInterval(this.clipboardWatcher);    }
  },
  watch: {
    value(v) {
      if (v) this.initForm();
      else {
        this.data = {};
      }
    },
    id() {
      if (!this.async || this._show) this.updateData(this.id);
    },
  },
  methods: {
    initForm() {
      this.loaded = false;
      this.updateData(this.id);
      if (!this.id) {
        this.loaded = true; ///  this.type = 1;
        //  this.data.status = 0;
      }
    },
    async checkClipboard() {
      try {
        const text = await navigator.clipboard.readText();
        const parsed = JSON.parse(text);
        this.clipboardHasValidJson = parsed && parsed.snapshot === "configData";
      } catch (e) {
        this.clipboardHasValidJson = false;
      }
    },
    async pasteData() {
      await this.checkClipboard();
      if (!this.clipboardHasValidJson) return;
      const text = await navigator.clipboard.readText();
      const data = JSON.parse(text)?.data;
      if (data)
        for (let i = 0; i < this.model.length; i++) {
          const m = this.model[i];
          this.data[m.name] = data?.[m.name];
        }
    },
    copyData() {
      let data = {};
      for (let i = 0; i < this.model.length; i++) {
        const m = this.model[i];
        data[m.name] = this.data?.[m.name];
      }
      this.copyToClipboard(JSON.stringify({ snapshot: "configData", data }));
    },
    copyToClipboard(v) {
      navigator.clipboard
        .writeText(v)
        .then(() => {
          this.$root.$emit("show-info", { color: "blue", text: "Скопировано..." });
        })
        .catch((err) => {
          this.$root.$emit("show-info", { type: "error", text: "Ошибка...." });
          console.error("Ошибка при копировании: ", err);
        });
    },
    getTitle() {
      //  {{ id ? title : "Новый элемент '" + title + "'" }}
      let res = "";
      if (this.id) res = this.title + (this.readonly ? " [Просмотр]" : " [Редактирование]");
      else res = this.title + " [Создание]";
      return res;
    },
    _submit() {
      if (this.readonly) return;
      if (this.configForm?.submitType == "emit") {
        this.$emit("submit", this.data);
        return;
      }
      const fields = this.configForm.head?.fieldsPost || "";
      this.submit(false, fields);
    },
    postData() {},

    afterFetchData(r) {
      let t = 0;
      if (this.m?.config?.watch) {
        t = this.data?.[this.m.config.watch] || 0;
      }
      this.getModel(t);
      this.loaded = true;
    },
    getModel(t) {
      let config = JSON.parse(JSON.stringify(this.config));
      let conf = JSON.parse(JSON.stringify(this.m?.config || {}));
      if (t || t === 0) config = JSON.parse(JSON.stringify(this.m?.config?.[t] || this.config));
      const f = conf.configField;
      if (f && this.data[f]) {
        if (Array.isArray(conf.config))
          config = conf.config.find((el) => {
            if (Array.isArray(el.value)) return el.value.includes(this.data[f]);
            return el.value == this.data[f];
          });
        else conf = conf.config;
      }
      //console.log("get model", t, config);

      if (this.data.status == 2 && this.m?.setAutoReadonly !== false) {
        config.fieldsRO = config.fields;
      }
      let model = this.calcModelConfig(config);

      if (config?.fields)
        model.forEach((el) => {
          if (el.hiddenCreate && !this.data?.id) {
            el.hidden = true;
          }
          if (!config.fields.split(",").includes(el.name)) el.hidden = true;
        });
      this.fillFormFromModel(model);
      this.model = model;
      this.inputData(this.initData);
    },
    afterSave(data, status) {
      console.log("after save");
      this.isChanged = false;
      if (this.m?.createAfterInsert === true && !this.id) {
        this.$emit("action", "createNew");
        this.$emit("input");
        return;
      }
      if (status) {
        if (this.opt?.closeAfterSave === false) {
        } else this.$emit("input");
      }
      if (this.opt?.closeAfterSave === true || this.opt?.closeAfterSave === undefined) this.$emit("input");
      let id = data.id;
      const name = this.opt?.routeName || this.m?.routeName;
      try {
        if (!this.id && name) {
          if (this.opt?.newWindow === true) {
            const name = this.m.routeName;
            const routeData = this.$router.resolve({ name, params: { id } });
            window.open(routeData.href, "_blank");
          } else this.$router.push({ name, params: { id } });
        }
      } catch (error) {}
    },
    doWatch(e) {
      if (e == this.m?.config?.watch) this.getModel(this.data?.[e]);
      //console.log("doWatch", e, this.config, this.model);
    },
    inputData(d = {}) {
      if (this.id) return;
      if (d) {
        for (const name in d) {
          let m;
          if ((m = this.model.find((m) => m.name == name))) {
            if (this.opt?.fieldsEditable == "*") {
            } else if (!(this.opt.fieldsEditable && this.opt.fieldsEditable.includes(name))) m.readonly = true;
          }
          this.$set(this.data, name, d[name]);
          this.$set(this.errors, name, null);
        }
      }
    },
    async _remove(api, id) {
      if (!api || !id) return;

      await this.remove(api, id);
      this.$emit("deleted");
      this.$emit("input");
    },
  },
};
</script>
